<template>
  <v-dialog v-model="dialog.conclude" persistent max-width="50%">
    <v-card>
      <v-card-title class="font-weight-bold">Confirmar conclusão</v-card-title>
      <v-spacer></v-spacer>
      <v-card-subtitle
        >Você está prestes a concluir as tratativas desse
        registro</v-card-subtitle
      >
      <v-divider></v-divider>

      <v-list dense>
        <v-list-item>
          <v-list-item-content>Usuário(a):</v-list-item-content>
          <v-list-item-content>{{ email }}</v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>Data da conclusão:</v-list-item-content>
          <v-list-item-content>{{
            new Date().toLocaleString()
          }}</v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-textarea
              label="Comentários adicionais"
              v-model="tratativa"
            ></v-textarea>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-checkbox
              v-model="checkbox"
              label="Confirmo a operação e tenho ciência que essa ação é irreversível."
            ></v-checkbox>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" :loading="loading" text @click="close()"
          >Cancelar</v-btn
        >
        <v-btn
          color="green darken-1"
          text
          @click="send()"
          :loading="loading"
          :disabled="!checkbox || !tratativa"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Conclude",

  data: () => ({
    picker: false,
    id: "",
    data_trat: new Date(),
    data_prev_conclusao: "",
    email: "TRIGO",
    tratativa: "",
    id_status: "2",
    id_tipo: "1",
    loading: false,
    checkbox: false,
  }),

  computed: {
    ...mapState(["dialog", "details"]),
  },

  methods: {
    ...mapMutations(["setDialog"]),
    ...mapActions(["getTimeline", "getData"]),

    close() {
      this.setDialog({ dialog: { conclude: false } });
      this.checkbox = false;
      this.tratativa = "";
    },

    send() {
      this.loading = true;
      fetch(
        "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev/tratativa",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: process.env.VUE_APP_AUTHORIZATION,
          },
          body: JSON.stringify({
            id: this.id,
            data_trat: this.data_trat.toISOString(),
            data_prev_conclusao: this.data_prev_conclusao,
            email: this.email,
            tratativa: this.tratativa,
            id_status: this.id_status,
            id_tipo: this.id_tipo,
          }),
        }
      ).finally(() => {
        this.close();
        this.getTimeline();
        this.getData();
        this.loading = false;
      });
    },
  },

  mounted() {
    this.id = this.details.id;
    this.email = this.$route.query.pad_email || this.email;
  },
};
</script>
